export enum SuperpowerOptionIdsEnum {
  ResourcefulAndLoveToRunBusiness = 'resourceful_and_love_to_run_business',
  ExperiencedWithMarketingAndAdvertising = 'experienced_with_marketing_and_advertising',
  CanCreateBestsellingDesigns = 'can_create_bestselling_designs',
  SeasonedEcommerceSeller = 'seasoned_ecommerce_seller',
  InfluencerWithStrongCommunity = 'influencer_with_strong_community',
}
